// Error hierarchy for the wire codec. Every failure throws a subclass
// of WireError so callers can branch on the specific failure mode or
// just catch the base.

export class WireError extends Error {
  override name = "WireError";
  constructor(message: string) {
    super(message);
  }
}

/** Length field is larger than the receiver's configured maximum. */
export class FrameTooLargeError extends WireError {
  override name = "FrameTooLargeError";
  constructor(
    public readonly length: number,
    public readonly max: number,
  ) {
    super(`frame length ${length} exceeds maximum ${max}`);
  }
}

/** Length field is < 2 (not enough room for type + flags). */
export class FrameTooShortError extends WireError {
  override name = "FrameTooShortError";
  constructor(public readonly length: number) {
    super(`frame length ${length} below minimum of 2 (must include type+flags)`);
  }
}

/** Type discriminant does not match any known frame. */
export class UnknownFrameTypeError extends WireError {
  override name = "UnknownFrameTypeError";
  constructor(public readonly typeByte: number) {
    super(`unknown frame type 0x${typeByte.toString(16).padStart(2, "0")}`);
  }
}

/** Payload ended mid-field. */
export class TruncatedPayloadError extends WireError {
  override name = "TruncatedPayloadError";
  constructor(
    public readonly expected: number,
    public readonly got: number,
  ) {
    super(`truncated frame payload: expected ${expected} bytes, got ${got}`);
  }
}

/** RES status is outside [100, 599]. */
export class InvalidStatusError extends WireError {
  override name = "InvalidStatusError";
  constructor(public readonly status: number) {
    super(`invalid status code ${status}`);
  }
}

/** WS_MSG opcode byte is not one of {0x1, 0x2, 0x9, 0xA}. */
export class UnknownWsOpcodeError extends WireError {
  override name = "UnknownWsOpcodeError";
  constructor(public readonly opcode: number) {
    super(`unknown WebSocket opcode 0x${opcode.toString(16).padStart(2, "0")}`);
  }
}
